import { ChevronDown, XCircle, InfoCircle, XClose } from "@untitled-ui/icons-react";
import { Typography } from "@kirvanobr/typography";
import React, { ReactNode } from "react";
import { ToastOptions, toast as showToast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { ToastFunction, ToastProps, ToastType } from "./Toast.types";

const iconVariants: Record<ToastType, ReactNode> = {
  [ToastType.Success]: <ChevronDown className="text-success text-3xl" />,
  [ToastType.Error]: <XCircle className="text-danger text-3xl" />,
  [ToastType.Warning]: <InfoCircle className="text-warning text-3xl" />,
  [ToastType.Info]: <InfoCircle className="text-primary text-3xl" />,
};

const toastFunctions: Record<ToastType, ToastFunction> = {
  [ToastType.Success]: showToast.success,
  [ToastType.Error]: showToast.error,
  [ToastType.Warning]: showToast.warning,
  [ToastType.Info]: showToast.info,
};

export const Toast: React.FC<ToastProps> & {
  success: (title: string, message: string) => void;
  error: (title: string, message: string) => void;
  warning: (title: string, message: string) => void;
  info: (title: string, message: string) => void;
} = ({ title, message, type }) => {
  const options: ToastOptions = {
    position: showToast.POSITION.TOP_RIGHT,
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    closeButton: <XClose className="text-foreground text-2xl" />,
    icon: iconVariants[type],
  };

  const showToastByType = (type: ToastType, message: string) => {
    const toastFunction = toastFunctions[type];
    if (toastFunction) {
      toastFunction(
        <div>
          <Typography size="t3" weight="bold" className="leading-normal">
            {title}
          </Typography>
          <Typography variant="assistant" size="t1" weight="medium" className="leading-none">
            {message}
          </Typography>
        </div>,
        options
      );
    }
  };

  showToastByType(type, message);

  return null;
};

Toast.success = (title: string, message: string) => {
  Toast({ title, message, type: ToastType.Success });
};

Toast.error = (title: string, message: string) => {
  Toast({ title, message, type: ToastType.Error });
};

Toast.warning = (title: string, message: string) => {
  Toast({ title, message, type: ToastType.Warning });
};

Toast.info = (title: string, message: string) => {
  Toast({ title, message, type: ToastType.Info });
};
